export default {
  ALL: 'All',
  BY_TIME: 'By time',
};
